export const recoverActionFailure = (current, { error, turnId, submittedText }) => {
  const sceneResponseFailed = ['NPC_REACTION_INVALID', 'NPC_RESPONSE_INVALID'].includes(error?.code);
  const retainRequest = sceneResponseFailed || error?.status === 0 || error?.status >= 500
    || ['ACTION_EXPIRED', 'INVALID_ACTION_RESPONSE'].includes(error?.code);
  return {
    ...current,
    isSubmitting: false,
    error: error?.message || 'Failed to submit action.',
    ...(sceneResponseFailed ? { draft: current.draft || submittedText } : {}),
    messages: current.messages.map(message => message.turnId === turnId && message.pendingAction
      ? { ...message, requestText: retainRequest ? submittedText : undefined,
        ...(error?.responseRetry ? { responseRetry: error.responseRetry } : {}) } : message),
  };
};

export const restorePendingResponse = (interaction, pending) => {
  if (!pending?.turnId || !pending.text) return interaction;
  const messages = interaction.messages.filter(message => message.turnId !== pending.turnId || !message.pendingAction);
  const userMessage = { role: 'user', content: pending.text, turnId: pending.turnId,
    ...(pending.responseRetry ? { responseRetry: pending.responseRetry } : {}),
    executionControl: pending.executionControl || undefined, pendingAction: true, requestText: pending.text };
  return { ...interaction, messages: [...messages, userMessage], isSubmitting: false,
    draft: interaction.draft || pending.text, error: 'The reply is pending. Submit the same instruction to retry this response.' };
};
